(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tl-behavior"] && !Shopify.designMode) return;
  try {
    (() => {
    const policy = document.querySelector('.shopify-policy__container');
    const policyConfig = document.getElementById('tl-policy-nav-config');
    if (policy && policyConfig && !policy.querySelector('.tl-policy-nav')) {
      const headings = [...policy.querySelectorAll('.shopify-policy__body h2')];
      if (headings.length > 1) {
        const details = document.createElement('details'); details.className = 'tl-policy-nav';
        const summary = document.createElement('summary'); summary.textContent = policyConfig.dataset.label;
        const nav = document.createElement('nav'); nav.setAttribute('aria-label', policyConfig.dataset.label);
        const list = document.createElement('ol');
        headings.forEach((heading, index) => {
          if (!heading.id) { let id = `tl-policy-section-${index + 1}`; while (document.getElementById(id)) id += '-x'; heading.id = id; }
          const item = document.createElement('li'), link = document.createElement('a');
          link.href = '#' + heading.id; link.textContent = heading.textContent.trim(); item.append(link); list.append(item);
        });
        nav.append(list); details.append(summary, nav); policy.querySelector('.shopify-policy__body').before(details);
      }
    }
    const header = document.querySelector('.tl-header');
    const measureHeader = () => {
      if (header) document.documentElement.style.setProperty('--tl-header-height', `${Math.ceil(header.getBoundingClientRect().height)}px`);
    };
    measureHeader();
    if (header && 'ResizeObserver' in window) new ResizeObserver(measureHeader).observe(header);
    const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
    const media = new Map();
    const completed = new WeakSet();
    const profiles = [
      ['.tl-production-story__scene-image img', 'film'],
      ['.tl-product-proof__frame img', 'proof'],
      ['.tl-appearance__sample img', 'sample'],
      ['.tl-batch__product img', 'lineup'],
      ['.tl-project-desk__casing img', 'casing'],
      ['[data-tl-motion]', 'legacy']
    ];
    const stop = (record) => {
      record.animation?.cancel();
      record.animation = null;
      record.waiting?.abort();
      record.waiting = null;
    };
    const finish = (node, record) => {
      stop(record);
      node.classList.remove('tl-motion-ready');
      completed.add(node);
      observer?.unobserve(node);
    };
    const play = (node, record) => {
      if (completed.has(node) || !record.visible || !node.isConnected) return;
      if (preference.matches || document.hidden) { finish(node, record); return; }
      if (node instanceof HTMLImageElement && !node.complete) {
        if (!record.waiting) {
          record.waiting = new AbortController();
          node.addEventListener('load', () => {
            record.waiting?.abort(); record.waiting = null; play(node, record);
          }, { once: true, signal: record.waiting.signal });
          node.addEventListener('error', () => finish(node, record), { once: true, signal: record.waiting.signal });
        }
        return;
      }
      if (!node.animate || (node instanceof HTMLImageElement && !node.naturalWidth)) { finish(node, record); return; }
      const mobile = window.matchMedia('(max-width: 700px)').matches;
      const film = record.profile === 'film' || record.profile === 'proof';
      const offset = mobile ? 6 : film ? 12 : 10;
      const start = { opacity: .86, translate: `0 ${offset}px`, scale: '1' };
      const end = { opacity: 1, translate: '0 0', scale: '1' };
      if (film && !mobile) {
        start.clipPath = 'inset(0 0 8% 0)'; end.clipPath = 'inset(0 0 0 0)';
        start.scale = '1.025';
      } else if (record.profile === 'sample' && !mobile) {
        start.translate = `${record.index % 2 ? 8 : -8}px 8px`; start.scale = '.99';
      }
      completed.add(node);
      record.animation = node.animate([start, end], {
        duration: mobile ? 360 : film ? 580 : 480,
        delay: mobile ? 0 : Math.min(record.index, 3) * 45,
        easing: 'cubic-bezier(.22,1,.36,1)', fill: 'none'
      });
      record.animation.onfinish = () => { record.animation = null; observer?.unobserve(node); };
    };
    const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const record = media.get(entry.target);
        if (!record) return;
        record.visible = entry.isIntersecting;
        if (entry.isIntersecting) play(entry.target, record);
        else if (record.animation) finish(entry.target, record);
      });
    }, { threshold: .12, rootMargin: '0px 0px -12px 0px' }) : null;
    const enhance = scope => {
      profiles.forEach(([selector, profile]) => {
        const nodes = [...scope.querySelectorAll(selector)];
        if (scope.matches?.(selector)) nodes.unshift(scope);
        nodes.forEach((node, index) => {
          if (media.has(node) || completed.has(node)) return;
          if (profile === 'legacy' && node.closest('#MainContent') && document.querySelector('tl-home-motion')) return;
          const record = { profile, index, visible: false, animation: null, waiting: null };
          media.set(node, record);
          if (!observer || preference.matches || document.hidden) { finish(node, record); return; }
          observer.observe(node);
        });
      });
    };
    const clearScope = scope => {
      media.forEach((record, node) => {
        if (node === scope || scope.contains(node)) { stop(record); observer?.unobserve(node); media.delete(node); }
      });
    };
    enhance(document);
    document.addEventListener('shopify:section:load', event => enhance(event.target));
    document.addEventListener('shopify:section:unload', event => clearScope(event.target));
    preference.addEventListener('change', () => {
      if (preference.matches) media.forEach((record, node) => finish(node, record));
    });
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) media.forEach((record, node) => finish(node, record));
    });
    window.addEventListener('pagehide', () => {
      observer?.disconnect(); media.forEach(record => stop(record)); media.clear();
    });
    window.addEventListener('pageshow', event => { if (event.persisted) enhance(document); });
    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      if (document.querySelector('dialog[open]')) return;
      const openMenu = event.target.closest('[data-tl-menu][open]') || [...document.querySelectorAll('.tl-header [data-tl-menu][open]')].reverse().find(menu => menu.getClientRects().length);
      if (!openMenu) return;
      event.preventDefault();
      openMenu.open = false;
      openMenu.querySelector('summary').focus();
    });
    document.addEventListener('click', (event) => {
      document.querySelectorAll('[data-tl-menu][open]').forEach((menu) => {
        if (!menu.contains(event.target)) menu.open = false;
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tl-page-compositions"] && !Shopify.designMode) return;
  try {
    (() => {
    const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
    let cleanup = () => {};
    const mount = () => {
      cleanup();
      const abort = new AbortController();
      const { signal } = abort;
      const toc = document.querySelector('.tl-route-taillai-guide .tl-toc');
      const links = toc ? [...toc.querySelectorAll('a[href^="#"]')] : [];
      const sections = links.map(link => document.getElementById(link.hash.slice(1)));
      const stages = [...document.querySelectorAll('.tl-route-delivery-and-warranty .tl-delivery__timeline li')];
      const progress = toc ? document.createElement('div') : null;
      if (progress) { progress.className = 'tl-reading-progress'; progress.setAttribute('aria-hidden','true'); document.body.append(progress); }
      let queued = false;
      const update = () => {
        queued = false;
        if (progress) {
          const first = sections.find(Boolean), last = sections.filter(Boolean).at(-1);
          if (first && last) {
            const start = first.getBoundingClientRect().top - 160;
            const end = last.getBoundingClientRect().bottom - window.innerHeight * .7;
            const fraction = Math.max(0,Math.min(1,-start / Math.max(1,end-start)));
            progress.style.setProperty('--reading-progress',fraction);
          }
          let active = 0;
          sections.forEach((section,index) => { if (section && section.getBoundingClientRect().top < 240) active = index; });
          links.forEach((link,index) => { if (index === active) link.setAttribute('aria-current','location'); else link.removeAttribute('aria-current'); });
        }
        stages.forEach((stage,index) => {
          const rect = stage.getBoundingClientRect();
          const visible = rect.top < window.innerHeight * .8 && rect.bottom > 130;
          stage.style.transitionDelay = preference.matches ? '0ms' : `${index * 75}ms`;
          stage.classList.toggle('is-current', visible);
        });
      };
      const schedule = () => { if (!queued) { queued = true; requestAnimationFrame(update); } };
      window.addEventListener('scroll',schedule,{passive:true,signal});
      window.addEventListener('resize',schedule,{passive:true,signal});
      preference.addEventListener('change',update,{signal});
      update();
      cleanup = () => { abort.abort(); progress?.remove(); };
    };
    mount();
    document.addEventListener('shopify:section:load',mount);
    document.addEventListener('shopify:section:unload',mount);
  })();
  } catch(e) { console.error(e); }
})();

})();
